<template>

<div class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full bg-gray-400 bg-opacity-50 z-50" v-if="feedback_modal">
  <div class="bg-white rounded-xl w-1/2" >
    <div class="flex flex-col items-start p-4">
      <div class="flex items-center w-full">
        <div class="text-gray-900 font-medium text-lg">Successfully Sent Feedback</div>
      </div>
      <div class="w-full items-center justify-center left-0 flex border-t border-gray-200 my-4"></div>
      <div class="">We love hearing your feedback and suggestion. With your thoughts, we can do better! Thanks.</div>
      <div class="w-full items-center justify-center left-0 flex border-t border-gray-200 my-4"></div>
      <div class="ml-auto">
          <button v-on:click="closeSuccessModal" class="bg-blue-500 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded-xl">
          Done
        </button>
      </div>
    </div>
  </div>
</div> 

<div id="side-bar" class="fixed top-0 h-full bg-white left-4 visible lg:invisible lg:-translate-x-20 -translate-x-0 duration-300 ease-in-out rounded-lg shadow-lg z-10"
  :class="{ 'hidden': side_bar_page == false }">
  <div class="h-full flex flex-col p-5">
    <a class="btn btn-ghost normal-case text-xl" v-on:click="home">
      <img class="object-contain h-8 inline" src="@/assets/tap-logo.png">
      <p class="text-sm inline text-gray-500">
        &emsp;Cloudstaff Tap
      </p>
    </a>

      <div class="overflow-y-scroll">
          <div class="bg-base-100 rounded-box rounded-3xl ">
                    <ul class="menu bg-base-100 menu-compact " id="tileScrollableSidebar">
                      <li >Books</li>
                      <li >FAQs</li>
                      <li >Feedbacks & Suggestions</li>
                      <li >Tile Content Display</li>
                      <li >Manage Sessions</li>
                    </ul>
          </div>
      </div>

    <div class="flex absolute bottom-2 right-2 justify-end mt-2" v-on:click="toggleSidebar()">
      <i class="text-green-500 font-bold blue-card px-3 py-1 rounded-full  text-right mr-3 cursor-pointer">&lt;</i>
    </div>
  </div>
</div>

<div class="fixed top-1/2 bg-white left-4 visible lg:invisible lg:-translate-x-20 -translate-x-0 duration-300 ease-in-out rounded-lg shadow-lg z-10" 
:class="{ 'hidden': side_bar_page == true }" v-on:click="toggleSidebar()">
  <div class="mx-1 my-10">
    <i class="text-green-500 font-bold text-center cursor-pointer blue-card px-3 py-2 rounded-full">></i>
  </div>
</div>


    <div class="card lg:card-side blue-card w-full lg:mr-12 rounded-3xl lg:ml-12 md:h-90vh  lg:h-90vh z-1">
      <div class="card-body">
        <div class="sm:flex sm:justify-between sm:flex mb-2 items-center">
          <div class="text-left">
            <p class="text-xl font-bold">
                  <span >Settings</span>
            </p>
          </div>
        </div>
        <div class="grid lg:grid-cols-6 grid-cols-5 xs:grid-cols-2 md:h-75vh lg:h-75vh rounded-3xl z-99">
          <div class="bg-base-100 rounded-box hidden lg:block rounded-3xl md:h-70vh lg:h-75vh">
            <p class="text-left font-bold p-4" ></p>
              <div >
                  <ul class="menu bg-base-100 menu-compact p-2 w-full overflow-y-auto md:h-50vh lg:h-55vh">
                    <li v-for="option in sideoptions" :key="option.key" v-bind:class="{ 'bg-gray-100 font-bold text-blue-500 rounded-3xl': selected_page === option }" v-on:click="selectPage(option)" v-bind:id="'page'+option.replace(/\s/g, '')"><a>{{option}}</a></li>
                   </ul>
              </div>
          </div>

          <div class="col-span-5 bg-base-100 px-5 lg:ml-5  md:h-70vh lg:h-75vh rounded-3xl">
            <!-- TILE CONTENT -->
             <header class="bg-base-100 text-left py-8 px-2 w-full">
                  <div class="flow-root ">
                      <p class="float-left font-bold text-2xl">
                                {{selected_page}}
                      </p>

                      <div v-if="selected_page == 'Books'">
                            <div class="float-right">
                              <label class="switch">
                                <input type="checkbox" v-model="web_only_switch" v-on:change="toggleWebOnlySwitch">
                                <span class="slider round"></span>
                              </label>
                            </div>
                      
                            <p class="float-right"> 
                                <small>Available on Web Only View &emsp;</small>
                            </p>
                      </div>

                      <div v-if="selected_page == 'Manage Sessions' && otpsession == true">

                            <p class="float-right"> 
                              <a class="inline-block bg-blue-500 hover:bg-blue-600 text-white text-xs font-semibold py-1 px-3 mr-2 rounded-full cursor-pointer"
                              @click="reloadsessionslist()">Refresh List</a>
                              <a class="inline-block bg-red-500 hover:bg-red-600 text-white text-xs font-semibold py-1 px-3 rounded-full cursor-pointer"
                              @click="logoutofalldevices(this.user_id)">Logout of all devices</a>
                            </p>
                      </div>
                  </div>

             </header>

             <div class="">
                <div class="w-full border-t border-gray-300"></div>
            </div>
             <div class="px-8 overflow-y-auto overflow-x-hidden text-left lg:h-60vh md:h-56vh">

                  <div v-if="selected_page === 'Books'">
                      <div class="grid grid-cols-3 gap-4 h-4/5">
                           <div class="col-span-3 ">
                              <div class='flex flex-wrap py-5'>
                                  <div class="form-check" v-for="bookdesc in this.$store.getters.book_and_desc" :key="bookdesc">
                                      <input class="radio-label hidden" style="display:none;" type="radio" name="book" value=""/>
                                      <label class="book-setting-button" for="book">
                                        <div class="float-right">
                                          <label class="switch" v-on:click="checkToggleButtonBook(bookdesc.title)">
                                            <input type="checkbox" 
                                            :checked="this.$store.getters.active_books.includes(bookdesc.title)"
                                            v-on:change="toggleBooks(bookdesc.title)"
                                            :disabled="this.$store.getters.active_books.includes(bookdesc.title) && this.$store.getters.active_books.length == 1"
                                           >
                                            <span class="slider round"></span>
                                          </label>
                                        </div>
                                        <p class="truncate"><strong>{{bookdesc.title}}</strong></p>
                                      
                                        <p class="truncate" v-if="bookdesc.desc != ''"><small>{{bookdesc.desc}}</small></p>
                                        <p class="truncate" v-else-if="bookdesc.desc == ''"><small>&emsp;</small></p>
                                      </label>
                                  </div>
                              </div>
                           </div>

                           <!-- <div class="vl">
                               <h2>Add a book</h2>
                               <input class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded-lg py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                      id="grid-first-name" 
                                      type="text" 
                                      v-model="book_code"
                                      placeholder="Book code e.g WELCOME">
                               <button v-on:click="addBook" 
                                        class="px-6 py-2 mt-8 text-white bg-blue-600 rounded-lg hover:bg-blue-900 float-right">
                                        Add
                               </button>
                           </div> -->
                      </div>
                  </div>

                  <div v-if="selected_page === 'FAQs'" class="mt-7">
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item bg-white border border-gray-200">
                        <div class="accordion-header mt-0" id="headingOne">
                          <button class="
                            accordion-button
                            relative
                            flex
                            items-center
                            w-full
                            py-4
                            px-5
                            text-base text-gray-800 text-left
                            bg-white
                            border-0
                            rounded-none
                            transition
                            focus:outline-none
                          " type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                            aria-controls="collapseOne">
                            How do I change to other books
                          </button>
                        </div>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample">
                          <div class="accordion-body py-4 px-5">
                               <p class="pb-4"><small>Click the tabs for books.</small></p>
                               <img src="@/assets/tap2.jpg" class="w-full mb-4">
                          </div>
                        </div>
                      </div>
                      <br>
                       <div class="accordion-item bg-white border border-gray-200">
                        <div class="accordion-header border-t-[1px] border-gray-200" id="headingTwo">
                          <button class="
                            accordion-button
                            collapsed
                            relative
                            flex
                            items-center
                            w-full
                            py-4
                            px-5
                            text-base text-gray-800 text-left
                            bg-white
                            border-0
                            rounded-nTwo
                            transition
                            focus:outline-none
                          " type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false"
                            aria-controls="collapseTwo">
                            I have a book code. What do I do with it?
                          </button>
                        </div>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample">
                          <div class="accordion-body py-4 px-5">
                               <p class=""><small>If you have a book code you want to add. Simply follow these steps:</small></p>
                               <p class=""><small>1. Click your profile icon located on the top right side of your screen.</small></p>
                               <p class=""><small>2. Click "Add Book" from the dropdown list.</small></p>
                               <p class="pb-4"><small>3. Enter the book code and click the "Add" button.</small></p>
                               <img src="@/assets/tap1.jpg" class="w-full mb-4">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="selected_page === 'Feedback & Suggestions'">
                        <div class="flex items-center justify-center w-full rounded-xl h-full lg:py-5 md:py-2" >
                        <div class="bg-white rounded-xl w-1/2 border">
                          <div class="flex flex-col items-start pr-8 pl-8 pb-4 pt-4">
                            <div class="flex items-center justify-center w-full">
                              <div class="text-gray-900 font-bold text-lg">Share us your experience</div>
                            </div>
                            <br>
                            <div class="w-full ">
                              <div class="w-full items-center justify-center flex ml-2">
                                 <div class="grid grid-cols-3 w-1/2 ">
                                  <div>
                                    <div class="flex items-center justify-center mt-8 relative">
                                      <div class="absolute">
                                        <img src="@/assets/bad-active.png" class="h-[75px]  inline mr-2 mb-5 cursor-pointer" v-if="emoji == 'Bad'">
                                      </div>

                                      <div class="absolute">
                                        <img src="@/assets/bad.png" class="h-[75px]  inline mr-2 mb-5 cursor-pointer" v-on:click="changeEmoji(1)">
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                      <div class="flex items-center justify-center mt-8 relative">
                                      <div class="absolute">
                                        <img src="@/assets/neutral-active.png" class="h-[75px]  inline mr-2 mb-5 cursor-pointer" v-if="emoji == 'Neutral'">
                                      </div>

                                      <div class="absolute">
                                        <img src="@/assets/neutral.png" class="h-[75px]  inline mr-2 mb-5 cursor-pointer" v-on:click="changeEmoji(2)">
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                      <div class="flex items-center justify-center mt-8 relative">
                                      <div class="absolute">
                                        <img src="@/assets/great-active.png" class="h-[75px]  inline mr-2 mb-5 cursor-pointer" v-if="emoji == 'Great'">
                                      </div>

                                      <div class="absolute">
                                        <img src="@/assets/great.png" class="h-[75px]  inline mr-2 mb-5 cursor-pointer" v-on:click="changeEmoji(3)">
                                      </div>
                                    </div>

                                  </div>
                                </div>

                              </div>
                               
                              <div class="form mt-14 relative">
                                   <label for="exampleFormControlTextarea1" class="form-label inline-block mb-2 text-gray-700"
                                ><small>Tell us your feedback or suggestion to help us improve the app</small></label>
                              <textarea
                                class="
                                  form-control
                                  block
                                  w-full
                                  min-h-[50%]
                                  h-4/5
                                  px-3
                                  py-1.5
                                  text-base
                                  font-normal
                                  text-gray-700
                                  bg-white bg-clip-padding
                                  border border-solid border-gray-300
                                  rounded-xl
                                  transition
                                  ease-in-out
                                  m-0
                                  focus:text-gray-700 focus:bg-white focus:border-blue-100 focus:outline-none
                                "
                                id="exampleFormControlTextarea1"
                                rows="5"
                                placeholder="Enter your message"
                                v-model="feedback"
                              ></textarea>
                              </div>
                             
                            </div>
                            <hr>
                            <br>
                            <div class="ml-auto">
                            
                              <button v-on:click="clearFeedbackSuggestions" :disabled="buttons_disabled" id="clear_btn_fas" class="bg-transparent hover:bg-gray-500 text-gray-600 font-medium hover:text-white py-2 rounded-xl px-4 border border-gray-500 hover:border-transparent mr-3 ">
                                Clear
                              </button>
                                <button v-on:click="submitFeedbackSuggestions" :disabled="buttons_disabled" id="send_btn_fas" class="bg-blue-500 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded-xl">
                                Send
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>

                  <div v-if="selected_page === 'Tile Content Display'">
                      <div class="grid grid-cols-3 gap-4 h-4/5">
                           <div class="col-span-3 ">
                              <div class='flex flex-wrap py-5'>
                                  <div class="form-check">
                                      <input class="radio-label hidden" style="display:none;" type="radio" name="book" value=""/>
                                      <label class="book-setting-button" for="book">
                                        <div class="float-right">
                                          <label class="switch">
                                            <input type="checkbox" 
                                            :checked="this.$store.getters.tile_view_display.includes('Progressive')"
                                            v-on:change="checkToggleTileDisplay()"
                                           >
                                            <span class="slider round"></span>
                                          </label>
                                        </div>
                                        <p class="truncate"><strong>Pagination</strong></p> <br>
                                        <p class=""><small>Pagination is a step by step process on tile view.</small></p>
                                        <br>
                                        <p class=""><small>If inactive, the tile display will be in scrollable view.</small></p>
                                      </label>
                                  </div>
                              </div>
                           </div>
                      </div>
                  </div>

                  <div v-if="selected_page == 'Manage Sessions'  && otpsession == true">
                      <div class="grid grid-cols-3 gap-4 h-4/5">
                           <div class="col-span-3 ">
                              <div class='flex flex-wrap py-5'>
                                  <div class="form-check m-1" v-for="session in this.session_list" :key="session">
                                      <input class="radio-label hidden" style="display:none;" type="radio" name="book" value=""/>
                                      <label class="book-setting-button" for="book">
                                        
                                        <div class="float-right">
                                          <label class="px-1">
                                            <span v-if="session.status === 'active'" class="inline-block bg-green-500 text-white text-xs font-semibold py-1 px-2 rounded-full ">Current</span>
                                            <span v-else class="inline-block hover:text-gray-400 text-gray text-xl font-bold rounded-full cursor-pointer "
                                            @click="logoutsession(session.id)"><i class="fa-light fa-circle-xmark"></i></span>
                                          </label>
                                        </div>

                                        <p class="truncate"><strong>{{session.device_info || 'Unknown'}}</strong> <small><i>({{session.device_type}})</i></small></p>
                                        <p class=""><small>LOCATION: {{session.location || 'Unknown' }} </small></p>
                                        <p class=""><small>IP: {{session.ip_public || 'Unknown' }} </small></p>
                                        <p class=""><small><i>{{formatDate(session.date_login)}}</i></small></p>
                                        <p class=""><small><i>{{session.device_identifier}}</i></small></p>
                                      </label>
                                  </div>
                              </div>
                           </div>
                      </div>
                  </div>

                  <div v-if="selected_page == 'Manage Sessions'  && otpsession == false">
                      <div class="grid grid-cols-3 gap-4 h-4/5">
                        <div class="col-span-3">
                          <div class='flex flex-wrap py-5'>
                            <p>To proceed with managing your sessions, we need to verify your identity.</p>
                          </div>
                          <!-- OTP input and verification section -->
                          <div v-if="otpsent == true">
                              <div class="flex flex-wrap py-5">
                              <input type="text" id="otp" placeholder="Enter OTP" class="px-4 py-2 border rounded mr-2" maxlength="6" v-model="otpinput"/>
                              <button class="px-6 py-2 bg-blue-500 text-white rounded" id="verifyButton" @click="verifyotpsession">Verify</button>
                              </div>
                              <!-- Resend OTP link -->
                              <div class="flex flex-wrap py-2">
                                <a href="#" class="text-blue-500 text-sm" id="resendOtpLink" @click="sendotpsession">Didn't receive the OTP? Resend</a>
                              </div>
                          </div>

                          <div v-else>
                              <!-- Resend OTP link -->
                              <div class="flex flex-wrap py-2">
                                <button class="px-6 py-2 bg-blue-500 text-white rounded" id="verifyButton" @click="sendotpsession">Send me the OTP</button>
                              </div>
                          </div>
                         
                        </div>
                      </div>
                  </div>
             </div>
          </div>
        </div>
      </div>
    </div>

</template>


<script src="../settings.js"></script>
